export const PAYLATER_ID = 6;
export const DIRECTUS_TRANSLATIONS_PRODUCT_ID =
  "e36b0553-107c-4af1-9f0c-837293316a5c";
